{
  "name": "@monorepo/app",
  "private": true,
  "version": "1.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "check": "tsgo -b",
    "check-watch": "tsgo -b --watch",
    "build": "vite build --mode production",
    "preview": "vite preview",
    "lint": "biome lint",
    "lint:fix": "biome lint --fix .",
    "i18n:extract-po": "node scripts/extract-to-po.mjs",
    "i18n:report-defaults": "node scripts/report-i18n-defaults.mjs",
    "i18n:po-to-json": "node scripts/po-to-json.mjs",
    "i18n:sync": "npm run i18n:extract-po && npm run i18n:po-to-json",
    "i18n:sync-defaults": "node scripts/po-to-json.mjs && node scripts/update-i18n-defaults.mjs",
    "shutdown": "kill -9 `lsof -t -i:3000`"
  },
  "dependencies": {
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.0",
    "@fontsource/roboto": "^5.2.5",
    "@fullcalendar/core": "^6.1.20",
    "@fullcalendar/daygrid": "^6.1.20",
    "@fullcalendar/interaction": "^6.1.20",
    "@fullcalendar/react": "^6.1.20",
    "@fullcalendar/resource": "^6.1.20",
    "@fullcalendar/resource-timeline": "^6.1.20",
    "@hookform/resolvers": "^5.0.1",
    "@mui/icons-material": "^7.1.1",
    "@mui/lab": "^7.0.1-beta.19",
    "@mui/material": "^7.1.1",
    "@mui/styled-engine-sc": "^7.1.1",
    "@mui/x-charts": "^8.5.1",
    "@mui/x-data-grid": "^8.28.0",
    "@mui/x-date-pickers": "^8.27.2",
    "@sentry/react": "^10.27.0",
    "@tanstack/react-query": "^5.80.6",
    "@tanstack/react-router": "^1.120.16",
    "axios": "^1.9.0",
    "date-fns": "^4.1.0",
    "i18next": "^25.6.0",
    "immer": "^11.0.0",
    "lodash": "^4.17.21",
    "mui-tel-input": "^9.0.1",
    "react": "^19.2.4",
    "react-dom": "^19.2.4",
    "react-hook-form": "^7.57.0",
    "react-i18next": "^16.2.4",
    "styled-components": "^6.1.18",
    "yup": "^1.6.1"
  },
  "devDependencies": {
    "@biomejs/biome": "2.5.2",
    "@sentry/vite-plugin": "^4.6.1",
    "@tanstack/react-query-devtools": "^5.80.6",
    "@tanstack/react-router-devtools": "^1.120.16",
    "@tanstack/router-plugin": "^1.120.16",
    "@types/react": "^19.2.13",
    "@types/react-dom": "^19.2.3",
    "@typescript/native-preview": "^7.0.0-dev.20260210.1",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-v8": "^4.1.4",
    "gettext-extractor": "^4.0.1",
    "gettext-parser": "^8.0.0",
    "globals": "^16.2.0",
    "i18next-cli": "^1.49.3",
    "i18next-conv": "^15.1.2",
    "playwright": "^1.52.0",
    "prop-types": "^15.8.1",
    "vite": "^8.0.8",
    "vite-plugin-compression2": "^2.0.1",
    "vite-plugin-svgr": "^4.5.0",
    "vitest": "^4.1.4"
  }
}
